module.exports = __webpack_public_path__ + "img/record2.f9b9ad8e.svg";